import pattern from 'patternomaly'

export const colors:any = {
  cattle: {
    'Cows (>3 years)': '#FFA500',
    'Cows (2-3 years)': '#FFA07A',
    'Heifers (1-2 years)': '#FF69B4',
    'Steers (1-2 years)': '#A05A32',
    'Weaned young heifers': '#F9BDF2',
    'Weaned young steers': '#F0874B',
    'Calves weaned this year': pattern.draw('diagonal', '#F0F03C'),
    'Unweaned calves': '#FFFF40',
    'Dry cows or heifers': '#800000',
    'Steers': '#B22222',
    'Bulls': '#FF0000'
  },
  sheep: {
    'Ewes (>2 years)': '#00A5FF',
    'Ewes (1-2 years)': '#7AA0FF',
    'Wethers (1-2 years)': '#003300',
    'Weaned young ewes': '#00D7FF',
    'Weaned young wethers': '#339966',
    'Lambs weaned this year': pattern.draw('diagonal', '#3BEDED'),
    'Unweaned lambs': '#40FFFF',
    'Dry ewes': '#000080',
    'Wethers': '#2222B2',
    'Rams': '#0000FF'
  },
  other: {
    'Total feed on offer': '#CCFFCC',
    'Total feed demand': '#993300',
    'Fresh supply + supplement': '#FF6600',
    'Fresh grown supply': '#00FF00',
    'Carryover': pattern.draw('diagonal', 'rgba(0, 255, 0, 0.3)'),
    'Supplement': pattern.draw('dot', '#FFA500'),
  }
}

// Generate random HSL color
export function randomColor () {
  var h = Math.floor(Math.random() * 60) + 15
  var s = Math.floor(Math.random() * 50) + 25
  var l = Math.floor(Math.random() * 25) + 25
  return 'hsl(' + h + ',' + s + '%,' + l + '%)'
}
